import { PHSAnalysisType } from '@domain/constant/phsAnalysisType';

import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './resultTab.module.scss';

const cx = classnames.bind(styles);

export type ResultMenuType = 'APPLY' | 'COMPETENCY';

interface IconProps {
  fill?: string;
}

const ApplyIcon = ({ fill }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_3804_7545)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.7999 12.3993V17.466H15.3332V12.3993H16.7999Z" fill={fill} />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.7999 18.7993V20.7993H15.3332V18.7993H16.7999Z" fill={fill} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3665 8.22984C14.5828 6.14474 17.5504 6.14474 18.7667 8.22984L18.7682 8.23248L25.7 20.2298L25.7009 20.2313C26.9157 22.3162 25.4364 24.9327 22.9999 24.9327H9.13325C6.69682 24.9327 5.21751 22.3162 6.4323 20.2313L6.43314 20.2298L13.3649 8.23248L13.3665 8.22984ZM14.634 8.96767L14.6334 8.96885L7.70155 20.9662L7.70002 20.9689C7.04967 22.0837 7.83691 23.466 9.13325 23.466H22.9999C24.2963 23.466 25.0835 22.0837 24.4331 20.9689L24.4316 20.9662L17.4998 8.96885L17.4991 8.96767C16.8486 7.85435 15.2846 7.85435 14.634 8.96767Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3804_7545">
          <rect width="20.1333" height="18.2667" fill={fill} transform="translate(6 6.66666)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CompetencyIcon = ({ fill }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5119 6.6633L20.9114 9.82967C20.9462 9.85007 20.9789 9.87309 21.0093 9.89839C21.9203 10.5234 21.8874 11.9121 20.9106 12.482C20.9102 12.4822 20.9098 12.4824 20.9094 12.4827L15.506 15.6513C14.4935 16.2336 13.2004 15.5173 13.2004 14.3223V7.98893C13.2004 6.80533 14.487 6.06169 15.5119 6.6633ZM14.6754 7.95356C14.6715 7.95996 14.6671 7.96981 14.6671 7.98893V14.3223C14.6671 14.3412 14.6714 14.3502 14.6746 14.3555C14.6791 14.3628 14.6874 14.372 14.7007 14.3796C14.7141 14.3872 14.7276 14.3904 14.7385 14.3906C14.747 14.3907 14.758 14.3893 14.7734 14.3807L20.1695 11.2163L20.1714 11.2152C20.1856 11.207 20.1908 11.1997 20.194 11.1939C20.1983 11.1861 20.2021 11.174 20.2021 11.1589C20.2021 11.1439 20.1983 11.1318 20.194 11.124C20.1908 11.1182 20.1856 11.1109 20.1714 11.1027C20.1441 11.0867 20.118 11.0692 20.0932 11.0501L14.7695 7.92818C14.7538 7.91899 14.7435 7.91773 14.7369 7.91782C14.7279 7.91794 14.7155 7.92062 14.7024 7.92814C14.6893 7.93566 14.6804 7.94521 14.6754 7.95356Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1472 17.8025C18.1472 17.3975 18.4755 17.0692 18.8806 17.0692H25.6606C26.0656 17.0692 26.3939 17.3975 26.3939 17.8025V24.5825C26.3939 24.9875 26.0656 25.3158 25.6606 25.3158H18.8806C18.4755 25.3158 18.1472 24.9875 18.1472 24.5825V17.8025ZM19.6139 18.5359V23.8492H24.9272V18.5359H19.6139Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.96669 18.2956C8.36874 18.2956 7.07336 19.591 7.07336 21.1889C7.07336 22.7869 8.36875 24.0823 9.96669 24.0823C11.5646 24.0823 12.86 22.7869 12.86 21.1889C12.86 19.591 11.5646 18.2956 9.96669 18.2956ZM9.96669 25.5489C7.55873 25.5489 5.60669 23.5969 5.60669 21.1889C5.60669 18.781 7.55873 16.8289 9.96669 16.8289C12.3747 16.8289 14.3267 18.781 14.3267 21.1889C14.3267 23.5969 12.3747 25.5489 9.96669 25.5489Z"
        fill={fill}
      />
    </svg>
  );
};

interface ResultTabProps {
  resultState: PHSAnalysisType | null;
  resultMenu: ResultMenuType;
  setResultMenu: (resultMenu: ResultMenuType) => void;
  isCompetency?: boolean;
}

const ResultTab = ({ resultState, resultMenu, setResultMenu, isCompetency = true }: ResultTabProps) => {
  const isOn = (menu: ResultMenuType) => menu === resultMenu;
  const isDisabled = resultState !== 'COMPLETED';

  const getColor = (isOn: boolean) => {
    return isOn ? Colors.C_WHITE : Colors.C_COOL_GRAY_60;
  };

  return (
    <div className={cx('btnArea')}>
      <button
        className={cx('btn', 'apply', { on: isOn('APPLY') })}
        onClick={() => setResultMenu('APPLY')}
        type="button"
      >
        <ApplyIcon fill={getColor(isOn('APPLY'))} />
        응시 분석결과
      </button>
      {isCompetency && (
        <button
          className={cx('btn', 'competency', { on: isOn('COMPETENCY') })}
          onClick={() => setResultMenu('COMPETENCY')}
          type="button"
          disabled={isDisabled}
        >
          <CompetencyIcon fill={getColor(isOn('COMPETENCY'))} />
          역량 분석결과
        </button>
      )}
    </div>
  );
};

export default ResultTab;
